// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"83cdf007","394":"d2942af8","453":"572c9268","579":"c1a17451","642":"125836bf","757":"a369ec18"}[chunkId] + ".chunk.js";
};